export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./form-vacancies.vue?vue&type=template&id=07c70abc&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/forms/form-vacancies.vue?vue&type=template&id=07c70abc&
// module id = 1034
// module chunks = 0